<template>
  <div>
    <v-container fluid>
      <material-card
        icon="mdi-clipboard-text"
        inline
        title="Edit ZM Allocation"
      >
        <v-card-actions>
          <router-link slot="right" :to="{ name: 'ZMAllocation' }">
            <v-btn
              v-if="$vuetify.breakpoint.smAndUp"
              elevation="1"
              absolute
              right
              top
            >
              <v-icon left>mdi-arrow-left</v-icon>back</v-btn
            >
            <v-btn
              v-else
              fixed
              right
              fab
              small
              color="grey lighten-2"
              elevation="1"
              class="mr-n2 mt-10"
              style="opacity: 0.6"
            >
              <v-icon>mdi-arrow-left</v-icon></v-btn
            >
          </router-link>
        </v-card-actions>
        <v-card flat class="px-2">
          <form autocomplete="off" @submit.prevent="save">
            <v-row>
              <v-col cols="12" md="6">
                <label class="font-weight-medium body-2">
                  Zone
                  <span class="requir error--text">*</span>
                </label>
                <v-autocomplete
                  class="my-0 py-1"
                  placeholder="--Select--"
                  v-model.trim="zoneDetails.zone"
                  required
                  :items="zoneList"
                  key="id"
                  item-value="id"
                  item-text="name"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <label class="font-weight-medium body-2">
                  Zonal Manager Name
                  <span class="requir error--text">*</span>
                </label>
                <v-autocomplete
                  class="my-0 py-1"
                  placeholder="--Select--"
                  v-model.trim="zoneDetails.zm"
                  required
                  :items="zmList"
                  key="id"
                  item-value="id"
                  item-text="displayZMName"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-card-actions class="d-flex justify-end">
                  <v-btn
                    bottom
                    right
                    elevation="1"
                    color="primary"
                    type="submit"
                  >
                    <v-icon left> mdi-content-save </v-icon>
                    Save
                  </v-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </form>
        </v-card>
      </material-card></v-container
    >
  </div>
</template>
<script>
import constants from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
import _ from 'lodash'

export default {
  name: 'updateZM',
  props: ['zmMappingID'],
  components: {
    MaterialCard
  },
  data () {
    return {
      zoneList: [],
      zmList: [],
      zonalManagerObj: {
        userID: '',
        zoneID: ''
      },
      zoneDetails: {
        zone: '',
        zm: ''
      },
      loader: false
    }
  },
  created () {
    this.getZonalManagerDetails()
    this.getZoneList()
    this.getZMList()
  },
  methods: {
    getZoneList: async function () {
      this.loader = true
      try {
        const { data } = await http.get(`${constants.API_URL}/api/get/zones`)
        this.zoneList = data
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(`while fetching zone list: ${errorMessage}`)
      }
    },
    getZMList: async function () {
      this.loader = true
      try {
        const { data } = await http.get(`${constants.API_URL}/api/get/user`)
        this.zmList = data
        this.zmList = _.map(this.zmList, (a) => {
          a.displayZMName = a.firstName + ' ' + a.lastName
          return a
        })
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(`while fetching ZM list: ${errorMessage}`)
      }
    },
    save: async function () {
      this.loader = true
      try {
        const data = {
          userID: this.zoneDetails.zm
        }

        await http.post(
          `${constants.API_URL}/api/update-zm/${this.zmMappingID}`,
          data
        )
        this.$router.push({ name: 'ZMAllocation' })
        this.okMsg('Zonal manager Updated successfully!')
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        // this.errMsg(`Error While Saving zonal manager: ${errorMessage}`)
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: `${errorMessage}`,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    getZonalManagerDetails: async function () {
      this.hasClicked = true
      this.loader = true
      try {
        const { data } = await http.get(
          `${constants.API_URL}/api/get/ZM/${this.zmMappingID}`,
          this.zonalManagerObj
        )
        this.zoneDetails.zone = data.id
        data.ams_zonalManagers.forEach((item) => {
          this.zoneDetails.zm = item.user.id
        })
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(`While fetching zonal manager by id: ${errorMessage}`)
      }
    },

    okMsg (msg) {
      return this.$dialog.info({
        title: 'Success',
        text: msg
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
